"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNavServiceV2 = void 0;
var cms_1 = require("./cms");
var constants_1 = require("./constants");
var GlobalNavServiceV2 = /** @class */ (function () {
    function GlobalNavServiceV2(isStudent) {
        this.sort = function (options) {
            return __spreadArray([], options, true).sort(function (item1, item2) { return item1.priority - item2.priority; });
        };
        this.map = function (cmsData) {
            return cmsData.map(function (item) {
                return ({
                    id: item.id,
                    code: item.internalId,
                    title: item.title,
                    priority: item.sequencer,
                    logo: item.curriculumLogo,
                    forStudents: item.forStudents,
                });
            });
        };
        this.isStudent = isStudent;
    }
    GlobalNavServiceV2.prototype.includeEmNav = function (items) {
        var CURRICULA_FOR_EM_NAV = ['em', 'emds']; // Eureka Math, Eureka Math
        var includeEmNav = items.some(function (item) { return CURRICULA_FOR_EM_NAV.includes(item.code); });
        return includeEmNav;
    };
    /**
     * Fetch CMS API Curricula and return data structured for Global Nav as a list of options for the dropdown
     * @returns
     */
    GlobalNavServiceV2.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, globalNavOptionsUnsorted, globalNavOptions, studentGlobalNavOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, cms_1.CMSService.getCurricula()];
                    case 1:
                        response = _a.sent();
                        globalNavOptionsUnsorted = this.map(response);
                        globalNavOptions = this.sort(globalNavOptionsUnsorted);
                        studentGlobalNavOptions = globalNavOptions.filter(function (item) { return item.forStudents !== false; });
                        if (this.isStudent)
                            return [2 /*return*/, studentGlobalNavOptions];
                        if (this.includeEmNav(globalNavOptions)) {
                            return [2 /*return*/, globalNavOptions.concat(constants_1.GLOBAL_NAV_FIXED_ITEMS.all)];
                        }
                        return [2 /*return*/, globalNavOptions.concat([constants_1.GLOBAL_NAV_FIXED_ITEMS.ManageItem])];
                }
            });
        });
    };
    return GlobalNavServiceV2;
}());
exports.GlobalNavServiceV2 = GlobalNavServiceV2;
